export type TwelveToneColors = { [key: string]: string }
export const TWELVE_TONE_COLORS: TwelveToneColors = {
  C: 'rgb(255,0,0,1)',
  'C#': 'rgb(128,0,0,1)',
  D: 'rgb(255,96,160,1)',
  'D#': 'rgb(255,253,55,1)',
  E: 'rgb(0,255,89,1)',
  F: 'rgb(0,213,255,1)',
  'F#': 'rgb(128,128,128,1)',
  G: 'rgb(0,0,255,1)',
  'G#': 'rgb(255,112,0,1)',
  A: 'rgb(0,112,0,1)',
  'A#': 'rgb(156,92,2,1)',
  B: 'rgb(160,0,255,1)',
}
